export const SESSION_EXPIRED_EVENT = "volvamed:session-expired";

export function shouldIgnoreSessionExpired(path) {
  return ["/therapist/signin", "/therapist/logout"].includes(
    String(path || "")
  );
}

export function emitSessionExpired({ role, path, code }) {
  if (typeof window === "undefined") return;

  window.dispatchEvent(
    new CustomEvent(SESSION_EXPIRED_EVENT, {
      detail: {
        role,
        path,
        code,
      },
    })
  );
}
